import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { getMatMasterAll, getMatTypeAll, getViewMatBookByDate } from "../api/matAPI";
 
const MatReport = (props) => {
  
    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [TypeOption,                      setTypeOption]               = useState([{ value:  'All', label: 'All'}]);
    const [typeOptionAll,                   setTypeOptionAll]            = useState([{ value:  'All', label: 'All'}]);
    const [matTypeOption,                   setMatTypeOption]            = useState([{ value:  'All', label: 'All'}]);
    const [type,                            setType]                     = useState({'Type': TypeOption[0].value, 'MatTypeID': matTypeOption[0].value});
    const [matReportTable,                  setMatReportTable]           = useState(null);
    const [isInit,                          setIsInit]                   = useState(true);
    const [matReport,                       setMatReport]                = useState([]);
    const [baseValuesWithGST,                      setBaseValuesWithGST]               = useState({baseBucket: 100, baseGarmin: 100, weekday: 100, weekend: 200, baseBucketForJR: 50}); //fallback values - updates from API
    const [baseValuesWithoutGST,                      setBaseValuesWithoutGST]               = useState({baseBucket: 84.8, baseGarmin: 84.8, weekday: 84.8, weekend: 169.5, baseBucketForJR: 41}); 

    useEffect(() => {
        props.title('Range Report ','range-report')
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        }); 
        fetchMatMasterAndType();
    }, [])
    
    const fetchMatMasterAndType = async () => {
        try {
            const mat = await getMatMasterAll();
            const modifiedMap = mat.filter(({ Active }) => Active === "Y").map(item => ({
                value: item.Number,
                label: item.Number,
                _raw: item
            }));
            const matTypes = await getMatTypeAll();
            const matTypesMap = matTypes.filter(({ Active }) => Active === "Y").map(item => ({
                value: item.ID,
                label: item.Type,
                _raw: item
            }));
            setMatTypeOption([{ value:  'All', label: 'All'}, ...matTypesMap]); 
            setTypeOptionAll([{ value:  'All', label: 'All'}, ...modifiedMap]);
            setTypeOption([{ value:  'All', label: 'All'}, ...modifiedMap]);
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    }

    useEffect(() => {       
        if (!isInit) {
            fillDataTable(type);
        }
    }, [matReport]);

    useEffect(() => {
        if(selectedFromDate && selectedToDate){
            fetchMatReport(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),)
        }
    },[selectedFromDate, selectedToDate])

    useEffect(() => {
        if(type && !isInit){
            $('#tblMatReport').KTDatatable().destroy(); 
            fillDataTable(type);
        }
        if (type?.MatTypeID !== "All") {
            let filteredType= typeOptionAll.filter((m)=>m.value !== 'All' && m._raw.MatTypeID == type.MatTypeID)
            setTypeOption([{ value:  'All', label: 'All'},...filteredType])
        } else {
            setTypeOption(typeOptionAll)
        }
    },[type])
 
    const fetchMatReport = async(fdate, tDate) => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const response = await getViewMatBookByDate(fdate, tDate);
            isInit ? setIsInit(false) : $('#tblMatReport').KTDatatable().destroy(); 
            setMatReport(response?.matReport)
            setBaseValuesWithGST(response?.baseValues)
            setBaseValuesWithoutGST(response?.baseValuesWithoutGST)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    } 

    const updateTypeDetails = (field, value) => {
        setType((d) => {
            return (field === "MatTypeID")
                ? { Type: 'All', [field]: value }   // special case
                : { ...d, [field]: value };         // normal update
        });
    };

    function exportSheet(type) {
        matReportTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Mat Report` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }


    function fillDataTable(t) {

        let noShowReportList = matReport.filter(i => {
            const matchType = t.Type === 'All' || i.Mat === t.Type;
            const matchMatType = t.MatTypeID === 'All' || i.MatTypeID === t.MatTypeID;
            return matchType && matchMatType;
        }) || [];

        const dataTable = $('#tblMatReport').KTDatatable({
            data: {
                saveState: false,
                source: noShowReportList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'ID',
                    title: 'Book ID',
                    width: 55,
                },
                {
                    field: 'MatType',
                    title: 'MatType',
                    width: 150,
                },
                {
                    field: 'Mat',
                    title: 'Mat',
                    width: 60,
                    template: function (row) {
                        return `<span class="tableexport-string"> ${row.Mat} </span>`
                    }
                },
                {
                    field: 'Slot',
                    title: 'Slot',
                    width: 120
                },
                // {
                //     field: 'BookDate',
                //     title: 'Play Date',
                //     width: 120,
                //     template: function (row) {
                //         return  ` <span class="tableexport-string" style="display:none;">${row.BookDate}</span><span class="tableexport-string">
                //                      ${moment(row.BookDate).format("DD-MMM-YYYY")}
                //                  </span>`
                //     }
                // },
                {
                    field: 'BookDate',
                    title: 'Play Date',
                    width: 120,
                    template: function (row) {
                        const isoDate = row.BookDate;
                        const displayDate = moment(isoDate).format("DD-MMM-YYYY");

                        return `<span>${displayDate}</span>`;
                    }
                },
                {
                    field: 'Name',
                    title: 'User Name',
                    width: 140,
                    template: function (row) {
                        if (row?.Name) {
                            return `<span class='kt-badge kt-badge--${row.UserType == "User" ? 'success' : (row.UserType == "Guest" || row.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Name}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'MemberType',
                    title: 'Member Type',
                    width: 90,
                },
                {
                    field: 'MembershipNo',
                    title: 'Membership No',
                    width: 120,
                },
                {
                    field: 'TransactionDate',
                    title: 'Transaction Date',
                    width: 120,
                    template: function (row) {
                        const isoDate = row.BookDate;
                        const displayDate = moment(isoDate).format("DD-MMM-YYYY");
                        return `<span>${displayDate}</span>`;
                    }
                },
                {
                    field: 'TransactionID',
                    title: 'TransactionID',
                    width: 150,
                },
                {
                    title: 'Entry Fee',
                    field: 'EntryFeeValue',
                    width: 60,
                },
                {
                    field: 'Bucket',
                    title: 'B. Qty',
                    width: 65,
                },
                {
                    field: 'BucketValue',
                    title: ' Bucket',
                    width: 65,
                },
                {
                    field: 'GarminValue',
                    title: ' Garmin',
                    width: 55,
                },
                {
                    title: 'GST Amt',
                    field: 'GstAmount',
                    width: 55,
                },
                {
                    field: 'Amount',
                    title: 'Amount',
                    width: 55,
                },
                {
                    field: 'Total',
                    title: 'Total',
                    width: 55,
                }
            ]
            ,
            rows: {
                autoHide: false,
            }
        });

        Config.Core.InitPopover();
 
        // export to excel
        const matReportTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Mat Report`,
        });
        setMatReportTable(matReportTable);
        $('.tableexport-caption').addClass('hidden');
        
    }
    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label text-right padding-l10">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label text-right padding-l10">To Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label text-right padding-l5">MatType </label>
                                    <div className="form-group col-sm-2 ">
                                        <div>
                                            <Select 
                                                id="ddlMatType" 
                                                name="ddlMatType"
                                                className="multi-custom"
                                                value={matTypeOption.find((m) => m.value == type.MatTypeID) || matTypeOption[0]}
                                                onChange={(event) => updateTypeDetails('MatTypeID', event.value)}
                                                options={matTypeOption}
                                            />
                                        </div>
                                    </div>
                                    <label className="col-form-label text-right pnlSlot padding-l5">Type </label>
                                    <div className="form-group col-sm-1 pnlSlot ">
                                        <div>
                                            <Select 
                                                id="ddlType" 
                                                name="ddlType "
                                                className="multi-custom "
                                                value={TypeOption.find((m) => m.value == type.Type) || TypeOption[0]}
                                                onChange={(event) => updateTypeDetails('Type', event.value)}
                                                options={TypeOption}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search Bay..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="tblMatReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default MatReport;